import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TSegmentOcr } from '../types';

import { segmentsQueryKeys } from './query-keys';

export async function deleteSegmentOcr(id: string): Promise<TSegmentOcr[]> {
  return mediaManagerClient.delete(`/api/v1/segment_ocr/${id}`).then(({ data }) => data);
}

type MutationFn = typeof deleteSegmentOcr;

type TUseDeleteSegmentOcrParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteSegmentOcr({ config }: TUseDeleteSegmentOcrParams) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: deleteSegmentOcr,
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar el rótulo del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El rótulo del segmento se ha eliminado correctamente'));
      queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.segmentLogo });
    },
  });
}
